import { map } from 'lodash';
import { errorHandler } from 'utils/errorHandler';


const LOAD = 'server-sts/timelineEvents/LOAD';
const LOAD_SUCCESS = 'server-sts/timelineEvents/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/timelineEvents/LOAD_FAIL';

const EXPORT_CSV_TIME = 'server-sts/timelineEvents/EXPORT_CSV_TIME';
const EXPORT_CSV_TIME_SUCCESS = 'server-sts/timelineEvents/EXPORT_CSV_TIME_SUCCESS';
const EXPORT_CSV_TIME_FAIL = 'server-sts/timelineEvents/EXPORT_CSV_TIME_FAIL';

import _ from 'underscore'



const initialState = {
  loaded: false,
  loading: false,
  success: false,
  error: false,
  data: [],

  exporting_csv: false,
  csv_created: false,
  csvString: null,
  csv_error: false,
  count:0,
  chunkIndex:0,
  begin_date:null,
  end_date:null

};

function removeDuplicates(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

export default function reducer(state = initialState, action = {}) {


  switch (action.type) {

    
    case LOAD:
      return {
        ...state,
        loading: true,
        chunkIndex:action.index
      };

    case LOAD_SUCCESS:

      const {result:{rows, concat, count, begin_date, end_date}} = action

      return {
        ...state,
        loading: false,
        loaded: true,
        data: concat ? removeDuplicates(state.data.concat(rows), 'id') : rows,
        count: count,
        error: false,
        begin_date, 
        end_date

      };
      

    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [],
        error: action.error
      };


    case EXPORT_CSV_TIME:
      return {
        ...state,
        exporting_csv: true,
        csv_created: false,
        csv_error: false,
      };

    case EXPORT_CSV_TIME_SUCCESS:
      return {
        ...state,
        exporting_csv: false,
        csv_created: true,
        csvString: action.result,
        csv_error: false,

      };

    case EXPORT_CSV_TIME_FAIL:
      return {
        ...state,
        exporting_csv: false,
        csv_created: false,
        csvString: null,
        csv_error: true
      };


    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.timelineEvents.data && globalState.timelineEvents.loaded;
}


export function load(params, begin_date, end_date, lastActivity = false, index=0, concat=false, disableLimit=false) {
  return {
    promise: (timelineEvents) => timelineEvents.post('/timelineEvents/load', { data: { params, begin_date, end_date, lastActivity, index, concat, disableLimit } }),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    index

  };
}

export function exportCSV(params, rows) {
  return {
    types: [EXPORT_CSV_TIME, EXPORT_CSV_TIME_SUCCESS, EXPORT_CSV_TIME_FAIL],
    promise: (timelineEvents) => createCsv(rows)
  };
}



function createCsv(rows) {
  return new Promise((resolve, reject) => {
    resolve(CSV(rows))
  })
}


//Returns a csv from an array of objects with
//values separated by tabs and rows separated by newlines
function CSV(array) {
  // Use first element to choose the keys and the order
  //var keys = _.keys(array[0]);




  var labels = [
    //"id",
    'Numéro installation gestionnaire',
    'Numéro installation prestataire',
    'Gestionnaire',
    "Complement d'adresse 2",
    'Programme',
    'Prestataire',
    'Adresse installation',
    'Complément d\'adresse',
    'Ville',
    'Code postal',
    'Début événement',
    'Fin événement',
    'Arrivée Tech',
    'Temps d\'immobilisation',
    'Cause événement',
    'Vandalisme',
    'Depart Tech',
    //'Période état indisponible',
    'Raison départ tech',
    'indispo_infos']

  var keys = [
    //'id',
    'Numero_Client',
    'Numero_Exploitant',
    'Gestionnaire',
    'Direction_Territoriale',
    'Groupe_HP',
    'Exploitant',
    'Adresse',
    'Repere',
    'Ville',
    'Code_Postal',
    'Date_debut',
    'Date_fin',
    'Date_Intervention',
    'Temps_dimmobilisation',
    'Description',
    'Vandalisme',
    'Fin_Intervention',
    //'etat_indisponible_periode',
    'Raison_depart_tech',
    'indispo_infos'
  ]

  // Build header
  var result = '\ufeff' + labels.join(";") + "\n";

  // Add the rows
  array.forEach(function (obj) {
    keys.forEach(function (k, ix) {
      if (ix) result += ";";
      result += obj[k];
    });
    result += "\n";
  });

  return result;
}


